(function() {
  'use strict';

  angular
    .module('admin.explore.customchannel.service', [])
    .factory('ExploreCustomChannelService', ExploreCustomChannelService);

  /** @ngInject */
  function ExploreCustomChannelService($http, $q, API) {

    function list(t, start, limit){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/channel_lists?t=' + t + '&start=' + start + '&limit=' + limit + '&sort=id-desc')
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listAll(){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/channel_lists')
          .success(defered.resolve)
          .error(defered.reject);

        return defered.promise;
    }

    function listClcs(id, start, limit){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/channel_lists/' + id + '/clcs?start=' + start + '&limit=' + limit + '&sort=n-asc')
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function get(id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/channel_lists/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function create(model){
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/channel_lists', model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function createClcs(id, model){
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/channel_lists/' + id + '/clcs', model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function update(id, model){
      var defered = $q.defer();

      $http.put(API.API_URL + 'admin/channel_lists/' + id, model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function updateClcs(parentId, id, model){
      var defered = $q.defer();

      $http.put(API.API_URL + 'admin/channel_lists/' + parentId + '/clcs/' + id, model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function remove(id){
      var defered = $q.defer();

      $http.delete(API.API_URL + 'admin/channel_lists/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function removeClcs(parentId, id){
      var defered = $q.defer();

      $http.delete(API.API_URL + 'admin/channel_lists/' + parentId + '/clcs/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return{
       list: list,
       listAll: listAll,
       listClcs: listClcs,
       get: get,
       create: create,
       createClcs: createClcs,
       updateClcs: updateClcs,
       update: update,
       remove: remove,
       removeClcs: removeClcs,
    };

  }

})();
